var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-data-table',{staticClass:"elevation-4",attrs:{"headers":_vm.headers,"items":_vm.list,"items-per-page":4,"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',[_c('td',[_c('chip-user-with-menu',{attrs:{"user":item.user,"colorChip":'primary'}})],1),_c('td',[_vm._v(_vm._s(_vm.formatDate(item.updated_at)))])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }